module.exports = __webpack_public_path__ + "kgrundwasser.7103b9e2d7432a0758f016dbe8d590ae.png";